import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cookieStorage from 'cookie-storage-v2';
import Collapsible from 'react-collapsible';


// import { rematchContext } from '../../models/index.model';

// Components
import BlockDetail from '../../components/BlockDetail/BlockDetail.component';
import { Button } from '@material-ui/core';

// type MyProps = { filterStore: any; summaryStore: any; getSummary: any };
// type MyState = { value: string };

const FORBIDDEN_REPORT_LABEL_UPERIO = [
  'summary (oncology)',
  'outlet activity (oncology)',
  'transaction view (oncology)',
  'patient overview (oncology)',
  'patient activity (oncology)',
  'pharmacy raw data (oncology)',
  'pharmacy overview (oncology)',
  'distributor (aam) report (oncology)',
];

const FORBIDDEN_REPORT_LABEL_ONCOLOGY = [
  'summary',
  'outlet activity',
  'transaction view',
  'patient overview',
  'patient activity',
  'pharmacy raw data',
  'pharmacy overview',
  'distributor (aam) report',
]
class PageContainer extends React.Component /*<MyProps, MyState>*/ {
  constructor(props) {
    super(props);

    this.state = {
      pageConfig: {
        blocks: [],
      },
    };
  }

  async componentDidMount() {
    await this._loadData();
  }

  async componentDidUpdate(prevProps) {

    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.search !== prevProps.location.search
    ) {
      await this._loadData();
      this.setState({ supportType: '' });

    }
  }

  /**
   * Filter block options based on user type for Stellar report.
   *
   * @param {Enum} userType nvid-oncology-user, nvid-uperio-user.
   * @param {Object} pageConfig Page config object.
   * @returns {Object}
   */
  filterAllowedButtons = (userType, pageConfig) => {
    let block = pageConfig.blocks[0];

    switch (userType) {
      case 'nvid-oncology-user':
        block = {
          ...block,
          block_options: {
            ...block.block_options,
            reports: block.block_options.reports.filter((item) => !FORBIDDEN_REPORT_LABEL_ONCOLOGY.includes(item.label.toLowerCase()))
          },
        };

        return block;
      case 'nvid-uperio-user':
        block = {
          ...block,
          block_options: {
            ...block.block_options,
            reports: block.block_options.reports.filter((item) => !FORBIDDEN_REPORT_LABEL_UPERIO.includes(item.label.toLowerCase()))
          },
        };

        return block;

      default:
        return pageConfig.blocks[0];
    }
  }

  _loadData = async () => {
    let block = [];
    this.setState({ pageConfig: {} });
    const programId = this.props.match.params.connect_program_id;
    const pageConfig = (await this.props.getPageConfiguration({
      connect_program_id: programId,
      page_key: this.props.match.params.page_key,
    })) || { blocks: [] };
    this.setState({ pageConfig });
    // TODO: Un-atomic, make it atomic, store it in auth reducer together along with localStorage
    // Quick Fix
    if (programId.includes('nvid')) {
      const userType = cookieStorage.getItem(`user-type`);

      if (pageConfig.blocks.length === 0) {
        return;
      }

      block = this.filterAllowedButtons(userType, pageConfig);
      this.setState({
        pageConfig: {
          ...pageConfig,
          blocks: [block]
        }
      });
    }
  };

  // render() {
  //   return (
  //     <div spacing={1}>
  //       {this.state.pageConfig.blocks &&
  //         this.state.pageConfig.blocks.map((blockConfig, idx) => {
  //           return (<BlockDetail
  //             key={blockConfig.id}
  //             blockConfig={blockConfig}
  //             {...this.props}
  //           />)
  //       })}
  //     </div>
  //   );
  // }


  
render() {
  const blocks = this.state.pageConfig?.blocks || [];
 // Titles for grouped and individually collapsible sections
  const nurseEducationData = ['Nucala doses', 'Appointment Schedule', 'Educational References'];
  const patientData = ['Alternative Funding Navigation', 'Prescription']; 

  // Categorize blocks
 const supportType = (this.state.supportType || '').trim();

let groupedBlocks = [];
let individualBlocks = [];

// pageBlocks → always same logic
const pageBlocks = blocks.filter(
  block =>
    !nurseEducationData.includes(block.block_options?.title) &&
    !patientData.includes(block.block_options?.title)
);

// NE group
if (supportType && supportType.includes('NE')) {
  groupedBlocks = blocks.filter(block =>
    nurseEducationData.includes(block.block_options?.title)
  );
}

individualBlocks = blocks.filter(block => block.block_options?.title === 'Prescription');

if (supportType && supportType.includes('AFN')) {
  individualBlocks = [
    ...individualBlocks,
    ...blocks.filter(
      block =>
        patientData.includes(block.block_options?.title) &&
        block.block_options?.title !== 'Prescription'
    )
  ];
}

  return (
    <div spacing={1}>
      {/* Render blocks without collapsible */}
      {pageBlocks.map(block => (
        <BlockDetail
          key={block.id}
          blockConfig={block}
          {...this.props}
    onSupportType={(type) => {
    this.setState({ supportType: type });
  }} />
      ))}

      {/* Render individual collapsible blocks */}
      {individualBlocks.map(block => (
        <Collapsible
          key={block.id}
          trigger={<div className="trigger">{block.block_options?.title}</div>}
          triggerWhenOpen={<div className="trigger open">{block.block_options?.title}</div>}
        >
          <BlockDetail
            blockConfig={block}
            {...this.props}
    onSupportType={(type) => {
    this.setState({ supportType: type });
  }}
          />
        </Collapsible>
      ))}

      {/* Render grouped collapsible section */}
      {groupedBlocks.length > 0 && (
        <Collapsible
          key="nurse-education"
          trigger={<div className="trigger">Nurse Education</div>}
          triggerWhenOpen={<div className="trigger open">Nurse Education</div>}
        >
          {groupedBlocks.map(block => (
            <BlockDetail
              key={block.id}
              blockConfig={block}
              {...this.props}
    onSupportType={(type) => {
    this.setState({ supportType: type });
    }}
            />
          ))}
        </Collapsible>
      )}
    </div>
  );
}

}

// REMATCH
const mapStateToPropsRematch = (state) => state;
const mapDispatchToPropsRematch = ({ reportingStore }) => {
  return {
    ...reportingStore,
  };
};

export default connect(
  mapStateToPropsRematch,
  mapDispatchToPropsRematch
)(PageContainer);

PageContainer.propTypes = {
  history: PropTypes.object,
  blockConfig: PropTypes.object,
  getPageConfiguration: PropTypes.func,
};
